module.exports = __webpack_public_path__ + "img/MZ.ebe1f020.svg";